import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import CategoryReducer from "../../containers/Category/redux/reducer";
import MenuReducer from "../../containers/Menus/redux/reducer";
import SignInReducer from "../../containers/signIn/redux/reducer";
import NewsReducer from "../../containers/news/redux/reducer";
import ConsoleReducer from "../../containers/console/redux/reducer";
import AdvertismentReducer from "../../containers/advertisement/redux/reducer";
import JobsReducer from "../../containers/Jobs/redux/reducer";
import TagsReducer from "../../containers/Tags/redux/reducer";
import LiveFeedReducer from "../../containers/liveFeed/redux/reducer";
import AdsUserReducer from "../../containers/AdsPlatform/redux/reducer";
import AdsCampaignReducer from "../../containers/AdsCampaign/redux/reducer";
import WarehouseReducer from "../../containers/dataWarehouse/redux/reducer";
import DatePickerReducer from "../../components/datePickerComponent/redux/date-picker-reducer";
import WidgetReducer from "../../containers/Widget/redux/reducer";

const rootReducer = combineReducers({
  categoryReducer: persistReducer(
    { key: "categoryReducer", storage: sessionStorage },
    CategoryReducer.reducer
  ),
  menuReducer: persistReducer(
    { key: "menuReducer", storage: sessionStorage },
    MenuReducer.reducer
  ),
  signInReducer: persistReducer(
    { key: "signInReducer", storage: sessionStorage },
    SignInReducer.reducer
  ),
  newsReducer: persistReducer(
    { key: "newsReducer", storage: sessionStorage },
    NewsReducer.reducer
  ),
  consoleReducer: persistReducer(
    { key: "consoleReducer", storage: sessionStorage },
    ConsoleReducer.reducer
  ),
  advertismentReducer: persistReducer(
    { key: "advertismentReducer", storage: sessionStorage },
    AdvertismentReducer.reducer
  ),
  jobsReducer: persistReducer(
    { key: "jobsReducer", storage: sessionStorage },
    JobsReducer.reducer
  ),
  tagsReducer: persistReducer(
    { key: "tagsReducer", storage: sessionStorage },
    TagsReducer.reducer
  ),
  liveFeedReducer: persistReducer(
    { key: "liveFeedReducer", storage: sessionStorage },
    LiveFeedReducer.reducer
  ),
  adsUserReducer: persistReducer(
    { key: "adsUserReducer", storage: sessionStorage },
    AdsUserReducer.reducer
  ),
  adsCampaignReducer: persistReducer(
    { key: "adsCampaignReducer", storage: sessionStorage },
    AdsCampaignReducer.reducer
  ),
  warehouseReducer: persistReducer(
    { key: "warehouseReducer", storage: sessionStorage },
    WarehouseReducer.reducer
  ),
  datePicker: persistReducer(
    { key: "datePicker", storage: sessionStorage },
    DatePickerReducer.reducer
  ),
  widgetReducer: persistReducer(
    { key: "widgetReducer", storage: sessionStorage },
    WidgetReducer.reducer
  ),
});

export default rootReducer;
